// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toolbar-footer {
  background-color: #f4f0e6;
}

.fs-footer {
  padding: 12px;
  font-size: 12px;
  flex-shrink: 0;
  height: 250px;
}

.fs-footer-copyright {
  font-size: 0.75rem;
  letter-spacing: 1.57px;
  line-height: 19px;
  text-align: right;
  color: #414042;
}

.fs-footer-logo {
  height: 30px;
}

:host-context(.teach-theme) .fs-footer-logo {
  height: 16px;
}

.fs-footer-icons {
  cursor: pointer;
  height: 26px;
  margin-right: 10px;
}

.footer-social-icon {
  height: 20px;
  padding-left: 4px;
}

.spacer {
  flex: 1 1 auto;
}

.fs-timestamp {
  font-size: 0.625rem;
  text-align: right;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/footer/footer.component.scss","webpack://./src/app/shared/styles/variables.scss"],"names":[],"mappings":"AAEA;EACI,yBCMe;ADPnB;;AAIA;EACE,aAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;AADF;;AAIA;EACE,kBAAA;EACA,sBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cCZgB;ADWlB;;AAIA;EACE,YAAA;AADF;;AAIA;EACE,YAAA;AADF;;AAIA;EACE,eAAA;EACA,YAAA;EACA,kBAAA;AADF;;AAIA;EACE,YAAA;EACA,iBAAA;AADF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,mBAAA;EACA,iBAAA;AADF","sourcesContent":["@import '../styles/variables.scss';\n\n.toolbar-footer {\n    background-color: $color-ecru-white;\n}\n\n.fs-footer {\n  padding: 12px;\n  font-size: 12px;  \n  flex-shrink: 0;\n  height:250px;\n}\n\n.fs-footer-copyright {  \n  font-size: 0.75rem;\n  letter-spacing: 1.57px;\n  line-height: 19px;\n  text-align: right;\n  color: $color-ship-gray;\n}\n\n.fs-footer-logo {\n  height: 30px;\n}\n\n:host-context(.teach-theme) .fs-footer-logo {\n  height: 16px;\n}\n\n.fs-footer-icons {\n  cursor: pointer;\n  height: 26px;\n  margin-right: 10px;\n}\n\n.footer-social-icon {\n  height: 20px;\n  padding-left: 4px;\n}\n\n.spacer {\n  flex: 1 1 auto;\n}\n\n.fs-timestamp {\n  font-size: 0.625rem;\n  text-align: right;\n}\n","$color-white: #fff;\n$color-black: #000;\n$color-silver: #bebebe;\n$color-mexican-red: #a41f35;\n$color-mine-shaft: #323232;\n$color-regal-blue: #003a71;\n$color-ship-gray: #414042;\n$color-azure: #31639e;\n$color-cararra: #e8e7e4;\n$color-ecru-white: #f4f0e6;\n$color-tall-poppy: #B62A39;\n$color-midnight-blue: #00315F;\n$color-pickled-bluewood: #34495E;\n$color-white-lilac: #F4F0F9;\n$color-hint-of-red: #F8F4F4;\n$color-dove-gray: #6C6C6C;\n$color-gray: gray;\n$color-gallery: #efefef;\n$color-dove-grey: #6a6a6a;\n$color-concrete: #f2f2f2;\n\n$font-title: 'EB Garamond', serif;\n$font-paragraph: 'Lato', sans-serif;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
